import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const objectGroup: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M16-9h-1v8h1v3h-3V1H3v1H0v-3h1v-8H0v-3h3v1h10v-1h3zm-2-2v1h1v-1zM1-11v1h1v-1zM2 1V0H1v1Zm11-1v-1h1v-8h-1v-1H3v1H2v8h1v1Zm2 1V0h-1v1Zm-5-8h3v6H6v-2H3v-6h7ZM4-4h5v-4H4Zm8 2v-4h-2v3H7v1zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "16",
  }
};
